// Mock data for Nyle Apparel landing page

export const brand = {
  name: "Nyle Apparel",
  email: "hello@nyleapparel.com",
  tagline:
    "Apparel manufacturing shaped by precision, responsibility, and innovation.",
};

export const nav = [
  { label: "About Us", href: "#about" },
  { label: "Our Vision", href: "#vision" },
  { label: "What We Do", href: "#what-we-do" },
  { label: "Our Philosophy", href: "#philosophy" },
  { label: "Contact", href: "#contact" },
];

export const hero = {
  titleTop: "Built to Scale.",
  titleBottomPre: "Designed",
  titleBottomPost: " to Flow.",
  description:
    "We partner with visionary brands to deliver high-quality garments through agile, technology-enabled manufacturing systems built for the modern world.",
  primaryCta: "Discover Our Approach",
  secondaryCta: "Contact Us",
  bgImage:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_web-launch-512/artifacts/nj292lxs_premium.webp",
};

export const about = {
  eyebrow: "ABOUT US",
  titlePre: "Building a new standard for ",
  titleAccent: "apparel manufacturing.",
  paragraphs: [
    "At Nyle Apparel, we are building a new standard for apparel manufacturing\u2014where precision, responsibility, and innovation come together to create lasting value.",
    "Founded with a future-focused vision, we partner with global brands to deliver high-quality garments through agile, technology-enabled manufacturing systems. Our approach goes beyond execution; we design supply solutions that are transparent, resilient, and built to adapt to an evolving global landscape.",
  ],
  quote:
    "We believe that the future of fashion will not be defined by scale alone, but by how intelligently and responsibly it is created.",
};

export const philosophy = {
  eyebrow: "OUR PHILOSOPHY",
  intro: "At Nyle Apparel, our approach is inspired by a simple yet powerful idea:",
  headline: "Be like water.",
  sub: "Water adapts, flows, and evolves\u2014yet remains essential, powerful, and enduring.",
  outro: "We bring this philosophy into every aspect of our business.",
  bgImage:
    "https://images.unsplash.com/photo-1468581264429-2548ef9eb732?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxjYWxtJTIwd2F0ZXJ8ZW58MHx8fHwxNzg0MzU5MjkwfDA&ixlib=rb-4.1.0&q=85",
};

export const footer = {
  companyLinks: [
    { label: "About Us", href: "#about" },
    { label: "Our Vision", href: "#vision" },
    { label: "What We Do", href: "#what-we-do" },
    { label: "Our Philosophy", href: "#philosophy" },
  ],
  legal: [],
  copyright: "\u00A9 2026 Nyle Apparel LLP. All rights reserved.",
};
